import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function slugify(text: string): string {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9 -]/g, "") // hapus karakter spesial
    .replace(/\s+/g, "-") // ganti spasi dengan -
    .replace(/-+/g, "-"); // hapus duplikat strip
}

export function formatRupiah(input: number | string): string {
  const number = typeof input === "string" ? parseFloat(input) : input;

  if (isNaN(number)) {
    return "-";
  }

  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  }).format(number);
}

const categoryColorMap: Record<string, string> = {
  hotspot: "bg-primary text-white",
  premium: "bg-blue-500 text-white",
  dashboard: "bg-green-500 text-white",
  web: "bg-yellow-400 text-black",
  default: "bg-gray-300 text-black",
};

export function getCategoryColorClass(category: string): string {
  const key = category.toLowerCase();
  return categoryColorMap[key] || categoryColorMap["default"];
}

export function applyHoverZoomOrigin(
  e: React.MouseEvent<HTMLElement, MouseEvent>,
  scale = 1.5,
) {
  const el = e.currentTarget;
  const rect = el.getBoundingClientRect();

  const offsetX = e.clientX - rect.left;
  const offsetY = e.clientY - rect.top;

  const originX = `${(offsetX / rect.width) * 100}%`;
  const originY = `${(offsetY / rect.height) * 100}%`;

  el.style.transformOrigin = `${originX} ${originY}`;
  el.style.transform = `scale(${scale})`;
}

export function resetHoverZoomOrigin(
  e: React.MouseEvent<HTMLElement, MouseEvent>,
) {
  e.currentTarget.style.transformOrigin = "center center";
  e.currentTarget.style.transform = "scale(1)";
}
